import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  label?: string;
  tone?: 'light' | 'dark';
};
export function Countdown({
  label = 'The special offer ends in:',
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: 'Hours'
  }, {
    value: minutes,
    unit: 'Min'
  }, {
    value: seconds,
    unit: 'Sec'
  }];
  const dark = tone === 'dark';
  return <div className="mt-8 flex flex-col items-center" role="timer" aria-live="off" data-id="element-99" data-mp="3h18weufg2681">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? 'text-brand-100' : 'text-brand-700'}`} data-id="element-100" data-mp="32483wopfi78i">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="374mcc7uxzj72" />
        {label}
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-102" data-mp="10a8ts6o1lvxe">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-103" data-mp="15an1fnlqf3uw" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-104" data-mp="y0wr1bdwlefq">
              <span className={`flex h-[72px] w-[72px] items-center justify-center rounded-xl font-serif text-4xl font-extrabold tabular-nums shadow-lg sm:h-20 sm:w-20 sm:text-5xl ${dark ? 'bg-white text-brand-800' : 'bg-brand-800 text-white'}`} data-id="element-105" data-mp="xzc1y1acynp9">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-bold uppercase tracking-widest ${dark ? 'text-brand-200' : 'text-muted'}`} data-id="element-106" data-mp="f1iz0yzqidrv">
                {u.unit}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold sm:pt-5 ${dark ? 'text-white' : 'text-brand-800'}`} aria-hidden="true" data-id="element-107" data-mp="k0ca6krjtsov">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}